import { handleActions } from 'redux-actions'
import { Record, fromJS } from 'immutable'

import { setStepIndex, setRun } from './actions'

class Tour extends Record({
  run: false,
  steps: fromJS([
    {
      target: '#user-activity-control-panel',
      content:
        'Welcome to your first MicroAction Go ahead and click “I commit” or “Pick another” to find one that’s a better fit',
      disableBeacon: true,
    },
    {
      target: '.add-to-favorites',
      content: 'Click here to keep track of your favorite activities so you can repeat them in the future',
      disableBeacon: true,
    },
    {
      target: '#dashboard-menu-item_team',
      content: 'Put down the pencil, we’ve got your progress tracked right here',
      disableBeacon: true,
    },
    {
      target: '.profile-dropdown__content',
      content: 'Go here to check your previous progress, change your delivery settings, or switch ProTracks',
      disableBeacon: true,
    },
    {
      target: '.feed',
      content: 'Here’s the leaderboard where you get a chance to show off how good you are at self-improvement',
      disableBeacon: true,
    },
    {
      target: '.feed',
      content: 'Lastly, check out what your team members are up to and read their stories',
      disableBeacon: true,
    },
  ]),
  stepIndex: 0,
}) {}

const handleSetStepIndex = (state, { payload }) => {
  if (payload === 3) {
    const ev = new CustomEvent('click', { bubbles: true })
    const el = document.getElementById('profile-dropdown')
    el.dispatchEvent(ev)
  }
  return state.set('stepIndex', payload)
}

const handleSetRun = (state, { payload }) => state.set('run', payload)

export default handleActions(
  {
    [setStepIndex]: handleSetStepIndex,
    [setRun]: handleSetRun,
  },
  new Tour()
)
